import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { first, Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { IUser } from '@app/models/user.interface'
import { FormGroup } from '@angular/forms';
import { selectCurrentPage } from '@app/modules/users/store/selectors/user.selectors';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  public endpoint: string = environment.apiUrl;
  public usersData$: State<IUser[]>;
  public users$: Observable<any>;
  public currentUserData$: State<IUser[]>;
  public currentUser$: Observable<any>;
  public locUsesAssetModuleData$: State<any>;
  public locUsesAssetModule$: Observable<any>;
  public locUsesCountingModuleData$: State<any>;
  public locUsesCountingModule$: Observable<any>;

  constructor(private _http: HttpClient, private store$: Store) {
    this.usersData$ = new State([]);
    this.users$ = select$(this.usersData$, data => data);
    this.currentUserData$ = new State([]);
    this.currentUser$ = select$(this.currentUserData$, data => data);
    this.locUsesAssetModuleData$ = new State(null);
    this.locUsesAssetModule$ = select$(this.locUsesAssetModuleData$, data => data);
    this.locUsesCountingModuleData$ = new State(null);
    this.locUsesCountingModule$ = select$(this.locUsesCountingModuleData$, data => data);
  }

  onGetUsers(sortType, direction) {
    let currentPage;
    this.store$.select(selectCurrentPage).pipe(first()).subscribe(current => currentPage = current);
    return this._http.get<any>(`${this.endpoint}/users`, {
      params: {
        sortType: sortType,
        direction: direction,
        currentPage: currentPage
      }
    });
  }

  onGetUser(id): Observable<any> {
    return this._http.get<any>(`${this.endpoint}/users/${id}`);
  }

  onGetTimezone(): Observable<any> {
    return this._http.get<any>(`${this.endpoint}/timezones`);
  }

  onUpdateUser(id, user): Observable<any> {
    return this._http.patch<any>(`${this.endpoint}/users/${id}`, user);
  }

  onSaveUser(user): Observable<any> {
    return this._http.post<any>(`${this.endpoint}/users`, user);
  }

  onCheckUser(usrUsername) {
    return this._http.get<any>(`${this.endpoint}/users/check`, {
      params: {
        usrUsername
      }
    });
  }

  onCheckEmail(usrEmail) {
    return this._http.get<any>(`${this.endpoint}/users/check-email`, {
      params: {
        usrEmail
      }
    });
  }

  me() {
    return this._http.get<any>(`${this.endpoint}/user`,{
      headers: {
        'deviceType': 'web'
      }
    });
  }

  updateMe(form: FormGroup): Observable<IUser> {
    return this._http.patch<any>(`${this.endpoint}/user`, {
      form
    });
  }

  changePassword(form: FormGroup): Observable<IUser> {
    return this._http.patch<any>(`${this.endpoint}/user/change-password`, {
      form
    });
  }

  deleteToken() {
    return this._http.get<any>(`${this.endpoint}/users/unauthorize`);
  }

  onDeleteUser(id) {
    return this._http.delete<any>(`${this.endpoint}/users/${id}`);
  }

  onSetIslocUsesAssetModuleData(v) {
    this.locUsesAssetModuleData$.next(v);
  }

  onSetIslocUsesCountingModuleData(v) {
    this.locUsesCountingModuleData$.next(v);
  }

  importExcel(keys: {}[], users: {}[]) {

    let headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    return this._http.post<any>(`${this.endpoint}/users/import`, {
      keys,
      users
    }, { headers });
  }

  exportExcel(): Observable<any> {
    return this._http.get(`${environment.apiUrl}/users/export`)
    .pipe(first());
  };

  getUserActivityLogs(params: any): Observable<any> {
    return this._http.get(`${environment.apiUrl}/user-activity-logs`, { params });
  } 
  // this.isExportLoading$ = true;

  // this._products.onGenerateExcel().pipe(first())
  // .subscribe((response) => {
  //   let rows = response['data'].products;
  //   // Excel Title, Header, Data
  //   // const title = 'Product Export';
  //   const header = [
  //     'SKU*',
  //     'Product Description*',
  //     'Barcode',
  //     'Brand',
  //     'UOM',
  //     'MSL1',
  //     'MSL2',
  //     'Category',
  //     'Area',
  //     'Cost',
  //     'Retail Price',
  //     'Count Type',
  //     'Count Type Quantity',
  //     'Custom Product Field'
  //   ];

  //   // Create workbook and worksheet
  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet('Sharing Data');

  //   // Add Row and formatting
  //   // const titleRow = worksheet.addRow([title]);
  //   // titleRow.font = { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true };
  //   // worksheet.addRow([]);

  //   // worksheet.mergeCells('A1:D2');


  //   // Blank Row
  //   // worksheet.addRow([]);

  //   // Add Header Row
  //   const headerRow = worksheet.addRow(header);

  //   // Cell Style : Fill and Border
  //   const mandatoryIndexes = [1, 2];
  //   headerRow.eachCell((cell, number) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'E1F4E4' },
  //       bgColor: { argb: 'FFFFFF' }
  //     };
  //     cell.font = {
  //       color: {
  //         argb: mandatoryIndexes.includes(number) ? "FF0000" : "000000"
  //       }
  //     }
  //     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //   });
  //   rows.forEach(item => {

  //     worksheet.addRow([
  //       item.prdCode,
  //       item.prdNameEn,
  //       item.barcodeData,
  //       item.prdBrand,
  //       item.prdCasePack,
  //       item.pcmMinQty1,
  //       item.pcmMinQty2,
  //       item.prdCatNameEn,
  //       item.areas.map(a => a.prdAreaNameEn).join(', '),
  //       item.pcmCost,
  //       item.pcmRetail,
  //       `${item.pcmDesc}`,
  //       item.pcmItemQty,
  //       item.prdCustomField1
  //     ]);
  //   });

  //   worksheet.getColumn(1).width = 15;
  //   worksheet.getColumn(2).width = 60;
  //   worksheet.getColumn(3).width = 14;
  //   worksheet.getColumn(4).width = 15;
  //   worksheet.getColumn(5).width = 15;
  //   worksheet.getColumn(6).width = 30;
  //   worksheet.getColumn(7).width = 30;
  //   worksheet.getColumn(8).width = 15;
  //   worksheet.getColumn(9).width = 15;
  //   worksheet.getColumn(10).width = 15;
  //   worksheet.getColumn(11).width = 15;
  //   worksheet.getColumn(12).width = 20;
  //   worksheet.getColumn(13).width = 20;
  //   worksheet.getColumn(13).width = 25;
  //   worksheet.addRow([]);

  //   // Generate Excel File with given name
  //   workbook.xlsx.writeBuffer().then((data: any) => {
  //     const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //     fs.saveAs(blob, 'trakrCountingProductExport.xlsx');
  //   }).finally(() => {
  //     this.isExportLoading$ = false;
  //   })
  // });
  // }

  /* Start Multilocations Service */
  onChangeToken(id,ids) {
    return this._http.post<any>(`${this.endpoint}/change-token`, { id: id, ids: ids });
  }
  /* End Multilocations Service */

  /* Contact support: identity is taken from the token on the server */
  onContactSupport(body: { subject: string; description: string; reply_email?: string; client?: { [key: string]: string } }) {
    return this._http.post<{ success: boolean }>(`${this.endpoint}/support/contact`, body);
  }
}
